/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Upload_Input_AriaInputs */

const vi_media_upload_input_aria = /** @type {(inputs: Media_Upload_Input_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn ảnh hoặc video để tải lên`)
};

/**

* @param {Media_Upload_Input_AriaInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_upload_input_aria = /** @type {((inputs?: Media_Upload_Input_AriaInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Upload_Input_AriaInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_upload_input_aria(inputs)
});